export const readEmpty = async (skip, query) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/listSuratEmpty?skip=${skip}&query=${query || ""}`;

    console.log("READ EMPTY URL:", url);

    const res = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    console.log("READ EMPTY STATUS:", res.status);

    const result = await res.json();

    console.log("READ EMPTY RESULT:", result);

    return result;
  } catch (error) {
    console.log("READ EMPTY FETCH ERROR:", error);

    return {
      success: false,
      data: [],
      error: error?.message || "Load failed",
    };
  }
};